//FlightDetails
export const GET_FLIGHTDETAILS_REQUEST = "GET_FLIGHTDETAILS_REQUEST";
export const GET_FLIGHTDETAILS_SUCCESS = "GET_FLIGHTDETAILS_SUCCESS";
export const GET_FLIGHTDETAILS_REQUEST_DONE = "GET_FLIGHTDETAILS_REQUEST_DONE";
export const GET_FLIGHTDETAILS_FAIL = "GET_FLIGHTDETAILS_FAIL";
export const SET_FLIGHTDETAILS = "SET_FLIGHTDETAILS";
export const FILTER_STATION = "FILTER_STATION";
export const DATA_RECEIVED = "DATA_RECEIVED";
export const RESET_FLIGHT = "RESET_FLIGHT";

//Station Names
export const GET_STATIONNAME_REQUEST = "GET_STATIONNAME_REQUEST";
export const GET_STATIONNAME_SUCCESS = "GET_STATIONNAME_SUCCESS";
export const GET_STATIONNAME_FAIL = "GET_STATIONNAME_FAIL";
export const SET_STATIONNAMES = "SET_STATIONNAMES";
export const SET_SELECTEDSTATION = "SET_SELECTEDSTATION";

//Loader value
export const FETCH_FLIGHTDETAILS_FROM_API = "FETCH_FLIGHTDETAILS_FROM_API";
